import { inject, Injectable } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

export const RoleGuard: CanActivateFn = (route, state) => {
    const router: Router = inject(Router);

    const type = localStorage.getItem('type');
    const allowedRoles = route.data?.['roles'] as string[] | undefined;

    // If no roles defined → allow access
    if (!allowedRoles || allowedRoles.length === 0) {
        return true;
    }

    // If user has permission → allow
    if (type && allowedRoles.includes(type)) {
        return true;
    }

    // ❌ Not allowed → redirect to their respective dashboard instead of sign-in
    // to prevent infinite loops when NoAuthGuard redirects back to '' -> /dashboard
    if (type === 'DEALER') {
        return router.parseUrl('/dealer/dashboard');
    } else if (type === 'BUSINESS') {
        return router.parseUrl('/corporate/dashboard');
    } else {
        return router.parseUrl('/dashboard');
    }
};